import { render } from "./BaseFooter.vue?vue&type=template&id=0492fd4a"
import script from "./BaseFooter.vue?vue&type=script&lang=js"
export * from "./BaseFooter.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ovvy_client_flyer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__